// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"85db6796-168":"7b79eee7344f2cab9ad4","85db6796-452":"08a4a86cc86d8919c45f","85db6796-379":"e8867b6dbe7034891559","85db6796-83":"ae48a6bc85dbb28b3b1b"}[chunkId] + ".js";
};